<template>
  <div>
    <div class="heading-4">Vote</div>
    <c-tx-steps
      class="mt-6"
      :options="steps"
      :current="currentStep"
      bgColor="purple"
    />
    <template v-if="currentStep === 1">
      <div class="mt-8 text-5">
        <div>Select an option to vote</div>
        <v-radio-group v-model="selectedOption" dense hide-details class="mt-5">
          <v-radio
            v-for="opt in proposal.finalTallyResult.details"
            :key="opt.key"
            :value="opt.optionValue"
            color="primary"
            small
          >
            <template v-slot:label>
              <div class="flex-1 d-flex align-center justify-space-between">
                <div>{{ opt.displayName }}</div>
                <div>{{ opt.rate }}%</div>
              </div>
            </template>
          </v-radio>
        </v-radio-group>
        <v-divider class="border-stake mt-5"></v-divider>
        <div class="d-flex align-center justify-end mt-5">
          <c-btn
            @click="currentStep = 2"
            :disabled="!selectedOption"
            walletRequired
            >Continue</c-btn
          >
        </div>
      </div>
    </template>
    <template v-if="currentStep === 2">
      <gas-option :gas="defaultGas" v-model="gasOption" class="mt-8">
        <br />
      </gas-option>
      <v-divider class="mt-5 border-stake"></v-divider>
      <div class="mt-5 text-4">
        <span class="font-weight-medium">Transaction Fee:</span>
        <span class="darkgray--text ml-4">
          <span>{{ gasOption.gasPrice | denomFormat }}</span>
          <span class="gray--text text-uppercase ml-1 text-5">{{
            currentProject.staking.token
          }}</span>
        </span>
      </div>
      <div class="mt-3 text-4">
        <span class="font-weight-medium">Vote option:</span>
        <span class="darkgray--text ml-4">{{ selectedVoteName }}</span>
      </div>
      <v-divider class="mt-5 border-stake"></v-divider>
      <div class="d-flex align-center justify-end mt-5">
        <c-btn
          @click="confirm"
          :disabled="gasOption.gas <= 0 || gasOption.gasPrice <= 0"
          walletRequired
          >Vote</c-btn
        >
      </div>
    </template>
    <tx-tendermint
      v-if="showTxDialog"
      name="gov_vote"
      title="Vote"
      successMesssage="Transaction sent"
      :getRawTx="getRawTx"
      :metadata="{ vote: selectedVoteName, id: proposal.id }"
      :gasOption="gasOption"
      @cancel="showTxDialog = false"
      @onSuccess="onTxSuccess"
    >
    </tx-tendermint>
  </div>
</template>

<script>
import BN from "bignumber.js";
import { mapGetters } from "vuex";
import GasOption from "../../components/GasOption";

export default {
  components: {
    GasOption,
  },
  props: {
    proposal: Object,
  },
  computed: {
    ...mapGetters({
      currentProject: "projectConfig/latestProject",
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
    }),
    defaultGas() {
      return this.currentProject.staking.gas.Vote;
    },
    defaultGasPrice() {
      return new BN(this.currentProject.staking.gasPriceStep.medium)
        .multipliedBy(this.defaultGas)
        .div(this.currentProject.staking.conversionRate)
        .toNumber();
    },
    gasPriceUsd() {
      return (
        this.getTokenPriceInUsd(this.currentProject.staking.token) *
        this.gasOption.gasPrice
      );
    },
    selectedVoteName() {
      return this.proposal.finalTallyResult.details.find(
        item => item.optionValue === this.selectedOption
      )?.displayName;
    },
  },
  data: () => ({
    currentStep: 1,
    steps: [
      {
        step: 1,
        text: "Vote option",
      },
      {
        step: 2,
        text: "Gas option",
      },
    ],
    selectedOption: null,
    gasOption: {
      gas: 0,
      gasPrice: 0,
    },
    showTxDialog: false,
  }),
  methods: {
    confirm() {
      this.showTxDialog = true;
    },
    async onTxSuccess() {
      this.showTxDialog = false;
      this.$emit("closeModal");
    },
    getRawTx() {
      return this.$store.dispatch("staking/tendermint/getVoteRawTx", {
        proposalId: this.proposal.id,
        proposalOption: this.selectedOption,
        memo: "",
        gas: this.gasOption.gas,
        gasPrice: new BN(this.gasOption.gasPrice)
          .multipliedBy(this.currentProject.staking.conversionRate)
          .toNumber(),
      });
    },
  },
};
</script>
